import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import QuestionForm from './index'
import RenderBody from '../../../modals/common/RenderBody'
import {currentTempPreviewItemSelector} from '../../../../modules/questions'
import {hideModal, TEMP_QUESTION_MODAL} from '../../../../modules/modals'


class TempQuestionFormModal extends Component {
    render() {
        let {currentTemp : {id : tempQuestionId, form : {errors : {recover = [], removeErr = []} = {}} = {}}, saveCB, removeCB} = this.props
        const {formatMessage} = this.context
        if (!tempQuestionId) return null
        let errors = [...recover, ...removeErr]

        return (
            <RenderBody
                title = {`${formatMessage(`titleSharedQuestion`)+` ID:`} ${tempQuestionId}`}
                modalClassName = "trashed-question-modal"
                bodyClassName="trashed-question-modal-body"
                handleClose={this.hideModal}
                render = {() => {
                    return (
                        <React.Fragment>
                            <QuestionForm viewMode = {true} questionId = {tempQuestionId} withTrashed = {true} isTemp = {true} />
                            {
                                !!errors.length &&
                                <div className="row">
                                    <div className="col-xs-12 text-danger">
                                        {
                                            errors.map(error => <p key = {error}>{formatMessage(error)}</p>)
                                        }
                                    </div>
                                </div>
                            }
                            <div className="create-dialog-form__group flex flex-between">
                                <button
                                    onClick = {this.hideModal}
                                    className="btn btn-default"
                                    type = "button"
                                >{formatMessage('frmPreviewSharedQuestionBtnCancel')}</button>
                                <button
                                    onClick={saveCB}
                                    className="btn btn-primary"
                                    type="button"
                                >{formatMessage('frmPreviewSharedQuestionBtnSave')}</button>
                                <button
                                    onClick={removeCB}
                                    className="btn btn-warning"
                                    type="button"
                                >{formatMessage('frmPreviewSharedQuestionBtnRemove')}</button>
                            </div>
                        </React.Fragment>
                    )
                } }
            />
        )
    }

    hideModal = () => this.props.hideModal({modalType : TEMP_QUESTION_MODAL})

    static propTypes = {
        saveCB : PropTypes.func.isRequired,
        removeCB : PropTypes.func.isRequired,
    }
    static contextTypes = {formatMessage: PropTypes.func}
}

export default connect(
    state => {
        const currentTemp = currentTempPreviewItemSelector(state) || {}
        return {
            currentTemp,
        }
    },
    {hideModal},
)(TempQuestionFormModal)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmBody/QuestionForm/TempQuestionFormModal.js